import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';

import type { Country } from 'hocs/countries/api/types';
import type { PhoneNumbersGroup } from 'hocs/telephony/api/types';

import FoundGroup from './foundGroup';

type PropsT = {
  group: PhoneNumbersGroup;
  country: Country;
  showBuyNumberModal: ({ group }: { group: PhoneNumbersGroup }) => void;
};

export default class ListGroups extends PureComponent<PropsT> {
  @boundMethod
  handleOnBuyClick() {
    const { showBuyNumberModal, group } = this.props;
    showBuyNumberModal({ group });
  }

  render() {
    const { group, country } = this.props;

    return (
      <FoundGroup
        group={group}
        country={country}
        onBuyClickHandle={this.handleOnBuyClick}
      />
    );
  }
}
